<template>
    <div class="templete_box">
        <div class="templete">
            <!-- <div class="search_box search_box_f clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.bill_type" placeholder="流水类型" @visible-change="getbillTypes()">
                    <el-option v-for="(list,index) in billTypes" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.bill_sn" placeholder="流水单号"></el-input>
                <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.operator_id" placeholder="付款人" @visible-change="getbillPayers()">
                    <el-option v-for="(list,index) in billPayers" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.order_type" placeholder="单据类型" @visible-change="getbillOrderTypes()">
                    <el-option v-for="(list,index) in billOrderTypes" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
               
            </div> -->
            <div class="tableBox">
                <tabletem :isShowIndex="true" :isSetCol="true" scene="redeem.bill.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getTableDelete="getTableDelete" @getRow="getRow" @relativefile="relativeFile" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal no_print">
                <div class="totalName">合计：</div>
                <div class="totalNumber">赎货余额: ￥{{tot.inout_amount}}</div>  
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="redeem.bill.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 融资成本明细 START -->
        <el-dialog v-dialog-drag :visible.sync="costLogDetailDialog" class="eldialogStock"
                width="490px" :modal="false" :title="'融资成本明细'" custom-class="full_dialog">
            <div class="tableBox" style="min-height: 250px;max-height: 400px">
                <tabletem :isShowIndex="true" :is-hide-checkout="false" :isHideColumn="false" :is-align-center="true"  :tablecol="costLogDetailTableCol" :tabledata="costLogDetailList">
                </tabletem>
            </div>
            <div style="padding: 5px;font-size: 15px;text-align: left;">
                合计  平摊金额:{{costLogtotal.amount}}
            </div>
            <!-- <div class="costLogBottomBtn" style="padding: 30px 0 0;">
                <el-button type="primary" @click="costLogDetailDialog=false">我知道了</el-button>
            </div> -->
        </el-dialog>
    </div>
</template>
<script>
    import tabletem from '../../../components/table.vue';
    import pagination from '../../../components/pagination.vue';

    export default {
        data() {
            return {
                module:localStorage.dw_erp_power_code,
                statistical:{},
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    bill_type:"",
                    bill_sn:"",
                    operator_id:"",
                    order_type:"",
                    page:1,
                    per_page:50,
                },
                last_page:1,
                total:0,
                tot:{},
                selectRow:[],
                list:[],
                filter:"",
                fields:"",
                filterDialogVisible:false,
                tableCol:[
                    {colName:"流水时间",colKey:"trading_time",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"流水类型",colKey:"finance_bill_type_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"流水金额",colKey:"inout_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"流水单号",colKey:"bill_sn",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"客户余额",colKey:"issuing_balance_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"付款人",colKey:"operator_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"金融公司名称",colKey:"issuing_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"单据类型",colKey:"order_type_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                tableLoading:false,
                start_time:"",
                end_time:"",
                selectMap:{},
                isShowMore:false,
                selectMapC:{
                    // supplier_id:[],
                    // breed_id:[],
                    // brand_id:[],
                    // port_id:[],
                    // grade_id:[],
                    // warehouse_id:[],
                    // original_length:[],
                    // original_thickness:[],
                    // status:[],
                    // bale_status:[],
                    // pieces:[],
                    // status_text:[],
                },
                costLogDetailDialog:false,
                costLogDetailList:[],
                costLogtotal:{},
                costLogDetailTableCol:[
                    {colName:"平摊日期",colKey:"fee_date",isDate:true,},
                    {colName:"费用类型",colKey:"fee_name"},
                    {colName:"平摊金额",colKey:"amount"},
                    {colName:"操作人",colKey:"creator_name"},
                ],
                account_id:"",
                billTypes:[],
                billPayers:[],
                billOrderTypes:[]
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.account_id = sessionStorage.getItem("STORE_ISSUING_ID")
            sessionStorage.removeItem("STORE_ISSUING_ID")
            this.getList();
            this.getbillTypes();//流水类型
            this.getbillPayers();//付款人
            this.getbillOrderTypes();//单据类型
        },
        methods:{
            getSelectList(target){
               
            },
            getbillTypes(){
                this.postFunc("/erp/issuing.bill.types",{id:this.account_id},res=>{
                    this.billTypes = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getbillPayers(){
                this.postFunc("/erp/issuing.bill.payers",{id:this.account_id},res=>{
                    this.billPayers = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getbillOrderTypes(){
                this.postFunc("/erp/issuing.bill.order.types",{id:this.account_id},res=>{
                    this.billOrderTypes = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSelectWarehouseList(target){
                this.params.types= 'finance';
                this.$getSelectWarehouseList(target,this.params,"","finance").then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            getList(){
                this.tableLoading = true;
                this.params.id = this.account_id;
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.$postColumnList("/erp/redeem.bill.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.list.last_page);
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.tot= res.data.data.total;
                    this.list=res.data.data.list.data;
                    this.list.forEach((item,index)=>{
                        item.baseColor = "";
                        this.list[index].trading_time = item.trading_time==0?'':this.formatTime(item.trading_time+"000")
                        if(item.inout_amount<0){
                            item.baseColor='red';
                        }else if(item.inout_amount>0){
                            item.baseColor='#007B04';
                        }
                        if(item.isDelete==1){
                            item.isDelete = true;
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                })
            },
            //删除
            getTableDelete(id){
                this.confirmLog("是否确认删除?",()=>{
                    this.postFuncLoading("/erp/redeem.bill.delete",{bill_id:id},()=>{
                        this.tip('删除成功','success');
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                });
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            getRow(row){
                this.selectRow=row;
            },
            filterConfirm(){
                this.getList()
            },
            rowClick(obj){
                if(obj.name =='finance_cost'){
                    this.postFunc('/erp/finance.cost.logs',{inventory_id:obj.id},res=>{
                        this.costLogDetailDialog = true;
                        let resD = res.data.data.data;
                        this.costLogDetailList.forEach((item,index)=>{
                           this.costLogDetailList[index].fee_date = this.formatTime(item.fee_date+"000");
                        })
                        this.costLogDetailList = Array.isArray(resD) ? resD : [];
                        this.costLogtotal = res.data.data.total;
                    })
                }
            },
            //合计
            getTableSummaries(params) {
                return this.$setSummaryFields(params,{
                    amount:2,
                    },total=>{
                });
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time="";
                this.end_time="";
                this.getList();
            },
            relativeFile(obj){
                // this.downLoadFileDialog = !this.downLoadFileDialog;
                // this.downFilesList = obj.files;
            },
            excelExport(){
                this.$exportExecl("/erp/issuing.bill.export","融资库存",this.params)
            },
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "isShowEditfinance":function(val){
                if(!val){
                    this.feeForm={}
                }
            }
        },
    }
</script>
<style scoped lang="scss">
    .banking_box {
        background-color: #fff;
        margin: 5px 0 0 5px;
        .show {
            display: flex;
            padding: 10px;
            margin-bottom: 2px;

            .item {
                flex: 1;
                display: flex;
                align-items: center;
                height: 100px;
                margin-right: 10px;
                box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
                border-radius: 6px;
                padding: 0 10px;

                .left_icon {
                    flex: 1;
                    text-align: left;

                    .top {
                        font-size: 18px;
                        color: #000;
                        /*font-weight: 500;*/
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .icon_item {
                            width: 26px;
                            height: 26px;
                            background-size: contain !important;
                            background-clip:content-box !important;
                            margin-right: 10px;
                        }
                    }

                    .bottom {
                        margin-top: 15px;
                        font-size: 26px;
                        text-align: center;
                        /*font-weight: 700;*/
                    }

                }


            }
        }
        .depositButton{background-color: #F9A602;color: #fff;padding: 8px 20px;float: left;margin-right: 15px;}

        .total {
            display: flex;
            margin: 2px 0;
            font-size: 14px;
            color: #000;

            .total_left {
                flex-basis: 60px;
                background-color: #fff;
                margin-right: 2px;
                padding: 10px;
                font-weight: 600;
            }

            .total_right {
                flex: 1;
                background-color: #fff;
                padding: 10px;
                text-align: left;

                span {
                    font-weight: 600;
                    margin-right: 20px;
                }
            }
        }

        .pag_box {
            background-color: #fff;
        }
    }
</style>